import { Link } from 'react-router-dom';
import MetaHead from '../components/MetaHead';

export default function ForbiddenPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center space-y-8">
      <MetaHead 
        title="403 - Adgang nægtet - Din Privat Psykolog" 
        description="Du har ikke adgang til denne side på Din Privat Psykologs hjemmeside."
      />

      <div className="space-y-4">
        <div className="w-20 h-20 rounded-full bg-rose-50 text-rose-800 flex items-center justify-center mx-auto text-3xl shadow-2xs border border-rose-200">
          <i className="fa-regular fa-lock" aria-hidden="true" />
        </div>
        <p className="text-xs font-mono uppercase tracking-widest text-rose-800 font-semibold">
          Fejl 403
        </p>
        <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-[#5f7365]">
          Adgang begrænset
        </h1>
        <p className="text-base text-[#465A4F] max-w-lg mx-auto leading-relaxed">
          Du har desværre ikke tilladelse til at tilgå denne ressource. Du kan gå tilbage til forsiden for at finde den information, du søger.
        </p>
      </div>

      <div className="flex flex-wrap items-center justify-center gap-4 pt-4">
        <Link
          to="/"
          className="px-6 py-3 bg-[#5f7365] hover:bg-[#4e6053] text-white font-semibold rounded-none text-sm transition-all duration-200 hover:-translate-y-1 inline-flex items-center gap-2 shadow-xs"
        >
          <i className="fa-regular fa-house" aria-hidden="true" />
          Gå til forsiden
        </Link>
        <Link
          to="/kontakt"
          className="px-6 py-3 bg-white hover:bg-[#FAF8F3] text-[#5f7365] font-semibold rounded-none border border-[#D5CEBF] text-sm transition-all duration-200 hover:-translate-y-1 inline-flex items-center gap-2"
        >
          <i className="fa-regular fa-envelope" aria-hidden="true" />
          Kontakt Marie
        </Link>
      </div>
    </div>
  );
}
